<template>
  <v-app id="decidedly">
    <v-main class="login-container">
      <v-container
        fluid
      >
        <v-row align="center" justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
            class="pt-6"
          >
            <v-form @submit.prevent="validateResetPasswordForm" class="mt-6">
              <v-card>
                <v-card-title class="d-flex align-center justify-center">
                    <div>
                      <v-img
                        alt="Decidedly Logo"
                        :src="require('../assets/logo-blue.svg')"
                        max-width="55"
                      ></v-img>
                    </div>
                    <div class="ml-2">
                      <div class="logo-title">
                        Decidedly
                      </div>
                      <div class="text-caption">
                        ALPHA
                      </div>
                    </div>
                </v-card-title>
                <v-card-text>

                  <v-text-field
                    v-model="email"
                    label="email"
                    name="login"
                    prepend-icon="mdi-account"
                    type="email"
                    :error-messages="emailErrors"
                    @blur="$v.email.$touch()"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn type="submit" class="ma-6" color="primary" :disabled="$v.email.$invalid || emailSentStatus.sent">{{working ? 'Sending...' : 'Send Reset Instructions'}}</v-btn>
                </v-card-actions>
              </v-card>
              <div v-if="emailSentStatus.sent" class="mt-4">
                <v-alert
                  dense
                  type="success"
                >
                  Instructions to reset your password have been sent. Check your email and when you have reset your password you can
                  <v-btn
                    light
                    small
                    href="/login"
                  >
                    Login
                  </v-btn>
                  again.
                  <!-- <router-link to="/login">Login</router-link> again. -->
                </v-alert>
              </div>
              <div v-if="emailSentStatus.failed" class="mt-4">
                <v-alert
                  dense
                  type="error"
                >
                  Sorry! Something went wrong and we were not able to send the reset password email. Please try again later.
                </v-alert>
              </div>
            </v-form>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app'

// Load the auth feature into the firebase namespace.
import 'firebase/auth'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      email: '',
      password: '',
      working: false,
      emailSentStatus: { 'sent': false, 'failed': false },
      errors: []
    }
  },
  mixins: [validationMixin],
  validations: {
    email: { required, email }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid email')
      !this.$v.email.required && errors.push('Email is required.')
      return errors
    }
  },
  methods: {
    validateResetPasswordForm: async function () {
      // console.log(`Validate called`)
      if (this.email && !this.$v.email.$invalid) {
        this.resetPassword()
      }
    },
    resetPassword: function () {
      this.working = true
      let self = this
      firebase.auth().sendPasswordResetEmail(this.email).then(function () {
        // Email sent.
        self.emailSentStatus.sent = true
        self.working = false
      }).catch(function (error) {
        // An error happened.
        if (error.code === 'auth/user-not-found') { // We won't warn users of bad requests/invalid emails to prevent discovery of valid emails in the system
          self.emailSentStatus.sent = true
        } else {
          self.emailSentStatus.sent = false
          self.emailSentStatus.failed = true
        }
        self.working = false
        // console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.login-container {
  background: #0e2887;
  /*background-image: url("IMAGE_URL"); fallback */
  background: linear-gradient(#3a52b5, #0e2887); /* W3C */
  /*background-image: linear-gradient(#3a52b5, #0e2887);*/
  color: white;
}
.comparison-list {
  display: flex;
  justify-content: space-around;
}
.logo-title {
  color: #1e40aa;
  text-transform: uppercase;
}
</style>
